import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPAGAA000, getPAHAA010 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { formatDate, shouldDisplayMenu, updateMenuVisibility } from '../../../utils';

const PAHAA010 = () => {
    const [dataFAQs, setDataFAQs] = useState([]);
    const [dataNews, setDataNews] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);
    const [menuData, setMenuData] = useState([]);

    const handleFAQsShow = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '소식';
            default:
                return '';
        }
    };

    useEffect(() => {
        getPAHAA010()
            .then(({ data }) => {
                setDataFAQs(data.faqs);
                setDataNews(data.news);
            })
            .catch((error) => console.log(error));
        window.scrollTo(0, 0);

        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
                setMenuData(data);
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            <div id="icon-boxes">
                <div className="container">
                    <div className="box-wapper">
                        <Link to="/pahab010" className="icon-box icon-box-chat">
                            <div className="item-icon">
                                <i className="icon icon-chat" />
                            </div>
                            <div className="item-title">채용광고 상품안내</div>
                            <div className="item-desc">채용정보를 위한 다양한 상품을 안내해 드립니다.</div>
                        </Link>
                        <Link to="/pahac010" className="icon-box icon-box-document">
                            <div className="item-icon">
                                <i className="icon icon-document" />
                            </div>
                            <div className="item-title">이용안내</div>
                            <div className="item-desc">채용공고 및 이력서 등록방법을 안내해 드립니다.</div>
                        </Link>
                        {shouldDisplayMenu('pahad010', menuData) && (
                            <Link to="/pahad010" className="icon-box icon-box-letter">
                                <div className="item-icon">
                                    <i className="icon icon-letter-bigger" />
                                </div>
                                <div className="item-title">이메일문의</div>
                                <div className="item-desc">덴탈잡에 궁금하신 점과 제안사항을 보내주세요.</div>
                            </Link>
                        )}
                        <Link to="#" className="banner-card-box">
                            <div className="item-title">고객센터</div>
                            <div className="item-time">
                                평일(월~금) 09:00 ~ 17:30<br></br>토·일·공휴일 휴무
                            </div>
                            <div className="item-phone-number">080-801-1580</div>
                        </Link>
                    </div>
                </div>
            </div>
            {/* Start Accordion */}
            {shouldDisplayMenu('pahae010', menuData) && (
                <div id="accordion">
                    <div className="container">
                        <div className="header-frame">
                            <h1>자주 묻는 질문</h1>
                            <Link to="/pahae010">
                                <span style={{ fontSize: '18px', color: '#333' }}>더보기</span>
                                <i className="icon icon-plus" />
                            </Link>
                        </div>
                        <div className="content-frame">
                            <ul className="accordion-list">
                                {dataFAQs && dataFAQs.length > 0 ? (
                                    dataFAQs.map((item, index) => {
                                        const isActive = activeIndex === index;
                                        return (
                                            <li
                                                className={`accodion-item ${isActive ? 'active' : ''}`}
                                                key={`faqs-${index}`}
                                            >
                                                <div
                                                    className={`accordion-question view-more-btn ${isActive ? 'active' : ''
                                                        }`}
                                                    onClick={() => handleFAQsShow(index)}
                                                >
                                                    <span className="accordion-feature">Q</span>
                                                    <span className="question-text">{item?.title}</span>
                                                    <i className="arrow-icon" />
                                                </div>
                                                <div
                                                    className={`accordion-ans content-terms ${isActive ? 'active' : ''
                                                        }`}
                                                    dangerouslySetInnerHTML={{
                                                        __html: item?.contentFile
                                                            ? `<div class="flex-center"><div class="accordion-feature red">A</div><div class="answer-text">${decodeHTML(
                                                                item?.contentFile,
                                                            )}</div></div>`
                                                            : 'No content available',
                                                    }}
                                                ></div>
                                            </li>
                                        );
                                    })
                                ) : (
                                    <div className="no-data">데이터없습니다</div>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            {/* End Accordion */}
            {/* Start notification */}
            {shouldDisplayMenu('pahaf010', menuData) && (
                <div id="notification">
                    <div className="container">
                        <div className="section-wrapper">
                            <div className="left-item">
                                <div className="header-frame">
                                    <h1 style={{ fontSize: '28px' }}>공지/소식</h1>
                                    <Link to="/pahaf010">
                                        <span style={{ fontSize: '18px', color: '#333' }}>더보기</span>
                                        <i className="icon icon-plus" />
                                    </Link>
                                </div>
                                <div className="content-frame">
                                    <ul className="table content-table">
                                        {dataNews && dataNews.length > 0 ? (
                                            dataNews.map((item, index) => {
                                                return (
                                                    <li className="flex wrap-item" key={`news-${index}`}>
                                                        <div className="flex wrap-left">
                                                            <div
                                                                className={`status ${item?.gubun === '01'
                                                                        ? 'blue'
                                                                        : item?.gubun === '02'
                                                                            ? 'green'
                                                                            : ''
                                                                    } `}
                                                            >
                                                                {getGubun(item?.gubun)}
                                                            </div>
                                                            <h4 className="item-title">
                                                                <Link to={`/pahaf020-${item?.seq}`}>{item?.title}</Link>
                                                            </h4>
                                                        </div>
                                                        <div className="date">{formatDate(item?.addDate)}</div>
                                                    </li>
                                                );
                                            })
                                        ) : (
                                            <div className="no-data">데이터없습니다</div>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="icon-box-right">
                                {shouldDisplayMenu('pagab010', menuData) && (
                                    <Link to="/pagab010" className="icon-box icon-box-gift">
                                        <div className="item-icon">
                                            <i className="icon icon-gift" />
                                        </div>
                                        <div className="wrap-meta">
                                            <div className="item-title">이벤트</div>
                                            <div className="item-desc">덴탈잡의 이벤트를 확인하세요.</div>
                                        </div>
                                    </Link>
                                )}
                                {shouldDisplayMenu('pagaj010', menuData) && (
                                    <Link to="/pagaj010" className="icon-box icon-box-document-harm">
                                        <div className="item-icon">
                                            <i className="icon icon-document-harm" />
                                        </div>
                                        <div className="wrap-meta">
                                            <div className="item-title">법정 의무교육 </div>
                                            <div className="item-desc">법정 의무교육을 확인하세요.</div>
                                        </div>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PAHAA010;
